import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { dataSharingSlice } from '@quantum/tools/dataSharing';
import analyticsReducer from './analyticsSlice';

export const rootReducer = combineSlices({
  [analyticsReducer.reducerPath]: analyticsReducer.reducer,
  [dataSharingSlice.reducerPath]: dataSharingSlice.reducer
});

const store = configureStore({
  reducer: rootReducer,
  devTools: 'development' === process.env.NODE_ENV ? { name: 'Assembler' } : false
});
export default store;
